import Container from "../../../component/container/Container";
import FilterRow from "../../../component/filter-row/FilterRow";
import SortableTable, {
  SortSettings,
} from "../../../component/sortable-table/SortableTable";
import "./WeightingPage.scss";
import { CustomerDataEntry } from "../../../service/utils/interfaces";

interface WeightingPageProps {
  customerList: CustomerDataEntry[];
  headerLine: string[];
  content: any[][];
  sortSettings: SortSettings | undefined;
  searchParam: string;

  changeSortAction: (col: number) => void;
  changeSearchParam: (val: string) => void;
  resetTable: () => void;
  setSelectedCustomer: (val: CustomerDataEntry) => void;

  width: number;
  darkMode: boolean;
}

const WeightingPageUI = (props: WeightingPageProps) => {
  return (
    <div className={"weighting-wrapper" + (props.darkMode ? " dark" : "")}>
      <div className="filter-row row">
        <FilterRow
          width={props.width}
          customerData={props.customerList}
          onChangeCustomerData={(val) => {
            props.resetTable();
            props.setSelectedCustomer(val);
          }}
          darkMode={props.darkMode}
        />
      </div>
      <Container darkTheme={props.darkMode}>
        <div className="column">
          <SortableTable
            id="audit-list"
            width={props.width}
            header={props.headerLine}
            data={props.content}
            standaloneTable
            isAuditTable
            currentSort={props.sortSettings}
            onSortChanged={props.changeSortAction}
            currentFilterKey={props.searchParam}
            onFilterChanged={props.changeSearchParam}
            rowsPerPage={25}
            darkMode={props.darkMode}
            sourceDownload="local"
          />
        </div>
      </Container>
    </div>
  );
};

export default WeightingPageUI;
